const recommendationAttributes = {
    TOPICS: 'topics',
    LOGOS: 'logos',
};

export default recommendationAttributes;
